exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".c-status[data-v-a64bccea]{width:10px;height:10px;border-radius:100%;margin:0 6px 0 8px}.c-gray[data-v-a64bccea]{background-color:#b6becb}.c-primary[data-v-a64bccea]{background-color:#ff5722}.c-green[data-v-a64bccea]{background-color:#75c791}.table-content[data-v-a64bccea],.table-title[data-v-a64bccea]{text-align:center;font-size:13px}.table-title[data-v-a64bccea]{color:#787878}.table-content[data-v-a64bccea]{color:#363636}", ""]);

// exports
